import { TC_ACTIONS, BRANDING_ACTIONS } from '../../constants/actions'

export const POLICY_STOARGE_FUNCTIONS = {  

  acceptTCPolicy: () => ({
    type: TC_ACTIONS.ON_ACCEPT_TC
  })

}

export const BRANDING_FUNCTIONS = {

  storeBrandSymbol: symbol => ({
    type: BRANDING_ACTIONS.ON_STORE_BRAND_SYMBOL,
    payload: symbol
  }),

  finishLoading: () => ({
    type: BRANDING_ACTIONS.ON_FINISH_LOADING
  }),

  getBrandData: symbol => ({
    type: BRANDING_ACTIONS.ON_GET_BRAND_DATA,
    payload: symbol
  })
  
}


// WEBPACK FOOTER //
// ./src/store/actions/auth.js